<template>
  <v-row
    v-if="results.length > 0 || contactPersonsForQuery.length > 0"
    class="new-wrapper min-height-100 pa-10"
    no-gutters
  >
    <v-col cols="12">
      <div
        :class="
          $vuetify.breakpoint.width < 960
            ? 'mb-2 custom-header-text new-font-bold'
            : 'mb-4 custom-header-text new-font-bold'
        "
      >
        Suchergebnisse für "{{ originalQuery }}"
      </div>
      <search-filter store-namespace="bildungsportalSearch" />
      <search-list store-namespace="bildungsportalSearch" />
    </v-col>
  </v-row>
  <no-search-results-display
    v-else
    search-path="/bildungsportal/search"
    sample-query="Meldungen"
    :show-sample-query="false"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SearchFilter from "@/components/filter/SearchFilter";
import SearchList from "@/components/lists/SearchList";
import NoSearchResultsDisplay from "@/components/ui/NoSearchResultsDisplay";
import { metricEventTypes, metricParents } from "@/lib";

export default {
  name: "BildungsportalSearch",
  components: {SearchList, SearchFilter, NoSearchResultsDisplay },
  mounted() {
    this.loadSearchMaterials();
    this.loadContactPersons();
    this.postHeartbeat({
      name: "Suchergebnisse Bildungsportal",
      type: metricEventTypes.PAGE_VISIT,
      parent: metricParents.BILDUNGSPORTAL,
      data: {
        bildungsportalMetric: true
      }
    });
    this.updateQuery();
  },
  methods: {
    ...mapActions("bildungsportal", ["loadSearchMaterials", "loadContactPersons"]),
    ...mapActions("metrics", ["postHeartbeat"]),
    updateQuery() {
      let query = this.$route.query.q;

      if (!query) query = "";

      this.$store.dispatch("bildungsportalSearch/setQuery", query);
      this.$store.dispatch("bildungsportalSearch/selectFilter", "Alle");
    }
  },
  watch: {
    $route: "updateQuery"
  },
  computed: {
    ...mapGetters({
      query: "bildungsportalSearch/getQuery",
      originalQuery: "bildungsportalSearch/getOriginalQuery",
      results: "bildungsportalSearch/filteredEntries",
      contactPersonsForQuery: "bildungsportalSearch/getContactPersonsForQuery"
    })
  }
};
</script>

<style scoped></style>
